import PropTypes from 'prop-types'
import { useTranslation } from '../../utils/translations'

import './LoadingSpinner.css'

export const LoadingSpinner = ({ size = 'md', tone = 'accent', className = '' }) => {
  const classes = [
    'loading-spinner',
    `loading-spinner-${size}`,
    tone === 'onAccent' ? 'loading-spinner-on-accent' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return <span className={classes} aria-hidden="true" />
}

export const LoadingOverlay = ({ message, children }) => {
  const { t } = useTranslation()
  // Callers normally pass a phase-specific message; fall back to a generic one.
  const text = message ?? t('common.loading')
  return (
    <div className="loading-overlay" role="status" aria-live="polite" aria-busy="true">
      <div className="loading-overlay-panel">
        <LoadingSpinner size="md" />
        {text ? <p className="loading-overlay-message">{text}</p> : null}
        {children}
      </div>
    </div>
  )
}

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md']),
  tone: PropTypes.oneOf(['accent', 'onAccent']),
  className: PropTypes.string,
}

LoadingOverlay.propTypes = {
  message: PropTypes.string,
  children: PropTypes.node,
}

export default LoadingSpinner
